import { Outlet, useParams } from "react-router-dom";
import PostsPage from "../../../modules/post/PostsPage";

const Tab4 = ({ routeBase = "/customer/posts" }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PostsPage routeBase={routeBase} />;
};

export default Tab4;
